import { useEffect, useState } from "react";

import config from '@/config';
import useCache from "@/hooks/useCache";
import useNavigateToArtwork from "@/hooks/useNavigateToArtwork";
import { NextButton, PrevButton } from '@/shared-components/buttons/components/SliderControls';
import ArtworkSliderCard from '@/shared-components/cards/components/ArtworkSliderCard';
import Loader from '@/shared-components/loader/Loader';
import FHSlider from '@/shared-components/sliders/components/FHSlider';

import ArtistArtworksHeader from '../../components/ArtistArtworksHeader';

import './styles/ArtworksSlider.css';

export default function ArtworksSlider({
  artistData,
  openArtistPreview,
  openEditArtist,
  profileData = null,
  internal = null,
}) {
  const [visibleArtworks, setVisibleArtworks] = useState({
    data: [],
    totalDocs: 0,
  });
  const [loadingMoreData, setLoadingMoreData] = useState(false);

  const { loading, fetchData, loadMoreData: fetchMoreData } = useCache(
    `artworks_of_${artistData._id}_in_${profileData._id}`,
    `${config.apis.api.url}/gallery/${profileData._id}/artist/${artistData._id}/artworks`,
    {
      includeSearchQueries: {
        artist_type: artistData.gallery_artist ? "artist" : "gallery_artist",
      },
      invalidateWhen: internal
        ? ["EDIT_ARTWORK", "DELETE_ARTWORK", "NEW_ARTIST", `${profileData._id}_REFRESH`]
        : [`${profileData._id}_REFRESH`],
    }
  );

  const loadMoreArtworks = async () => {
    if (visibleArtworks.data.length < visibleArtworks.totalDocs) {
      setLoadingMoreData(true);
      try {
        await fetchMoreData();
      } catch (error) {
        console.error('Error al cargar más datos:', error);
      } finally {
        setLoadingMoreData(false);
      }
    }
  };

  const navigateToArtwork = useNavigateToArtwork(
    `artworks_of_${artistData._id}_in_${profileData._id}`,
    fetchData,
    `/gallery/${profileData._id}/artist/${artistData._id}/artworks?artist_type=${
      artistData.gallery_artist ? "artist" : "gallery_artist"
    }`
  );

  useEffect(() => {
    if (!loading && fetchData) {
      setVisibleArtworks(fetchData);
    }
  }, [loading, fetchData]);

  return (
    <div className="artist-artworks-slider__container">
      <div
        className="artist-artworks-slider__header"
        onClick={() => openArtistPreview(artistData)}
      >
        <ArtistArtworksHeader artistData={artistData} openEditArtist={openEditArtist} />
      </div>

      <FHSlider
        speed={1.4}
        className="artist-artworks-slider__slider element-non-selectable"
        customPrevButton={<PrevButton />}
        customNextButton={
          loadingMoreData ? <Loader /> : <NextButton />
        }
        onSlideEnd={loadMoreArtworks}
      >
        {loading ? (
          <Loader className="artist-artworks-content__content-spinner" thin />
        ) : (
          visibleArtworks.data &&
          visibleArtworks.data.map((artwork) => (
            <ArtworkSliderCard
              key={artwork._id}
              artworkData={artwork}
              imageClassName="artist-artworks-slider__slider-item-image"
              cardClassName="artist-artworks-slider__slider-item"
              onClick={() => navigateToArtwork(artwork.slug)}
            />
          ))
        )}
      </FHSlider>
    </div>
  );
}
